import { createAsyncThunk } from "@reduxjs/toolkit";

import Api from "api";

export const loginUser = createAsyncThunk("user/loginUser", async (loginData, thunkApi) => {
  return await Api.login(loginData).catch((message) => thunkApi.rejectWithValue(message));
});
